import { getDemandReportUsers } from '@api/user/apiService';
import { DemandReportUser } from '@api/user/model/types';
import InputFieldWithDebounce from '@components/InputFieldWithDebounce/ui/InputFieldWithDebounce';
import Table from '@components/Table/ui/Table';
import { ToggleTab, ToggleTabItemType } from '@components/ToggleTab';
import NoUsersFound from '@features/NoUsersFound/NoUsersFound';
import { TableRowActions } from '@features/TableRowActions/ui/TableRowActions';
import LinkIcon from '@icons/LinkIcon/LinkIcon';
import { IconButton } from '@shared/components';
import getDemandReportHeaderList from '@shared/tables/DemandReport/DemandReport';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getDateRange } from '../model/utils';
import styles from './SettingsDemandReportUsers.module.scss';

const dataRangeList: ToggleTabItemType[] = [
  { label: 'Last 24h', value: '24h' },
  { label: 'Last week', value: '7d' },
  { label: 'Last month', value: '30d' },
  { label: 'Last quarter', value: '90d' },
  { label: 'Month to date', value: 'mtd' },
];

const renderNoUsersFound = () => <NoUsersFound />;

function SettingsDemandReportUsers() {
  const [itemsPerPage] = useState(9);
  const [demandReportList, setDemandReportList] = useState<DemandReportUser[]>(
    []
  );
  const [dataRange, setDateRange] = useState('7d');
  const [searchValue, setSearchValue] = useState<string>('');

  const onSearchChange = (nextSearchValue: string) => {
    setSearchValue(nextSearchValue);
  };

  const fetchDemandReportList = (period: string) => {
    const dateRange = getDateRange(period);
    getDemandReportUsers(dateRange, (data: DemandReportUser[]) => {
      setDemandReportList(data);
    });
  };

  useEffect(() => {
    fetchDemandReportList(dataRange);
  }, [dataRange]);

  const dataList = useMemo(() => {
    return demandReportList.filter((item) =>
      searchValue
        ? item.name.includes(searchValue) || item.email.includes(searchValue)
        : true
    );
  }, [demandReportList, searchValue]);

  const handleRowActions = useCallback(
    (classname: string) => (
      <TableRowActions
        classname={[classname, styles.actionColumn].join(' ')}
        style={{ justifyContent: 'flex-start', width: '100%' }}
      >
        <IconButton variant="underline" className={styles.dashboardIcon}>
          <LinkIcon />
        </IconButton>
      </TableRowActions>
    ),
    []
  );

  return (
    <div className={styles.SettingsDemandReportUsersWrapper}>
      <div className={styles.header}>
        <ToggleTab
          activeTab={dataRange}
          setActiveTab={setDateRange}
          tabList={dataRangeList}
        />

        <div className={styles.demandsSearch}>
          <InputFieldWithDebounce
            debounceAction={onSearchChange}
            image={<img src="/icons/search.svg" alt="" />}
            placeholder="Search demands..."
            name="searchInput"
          />
        </div>
      </div>

      <Table
        noDataRenderer={renderNoUsersFound}
        onRowClick={() => {}}
        itemsPerPage={itemsPerPage}
        columns={getDemandReportHeaderList()}
        style={{ marginTop: '24px' }}
        data={dataList}
        rowActions={handleRowActions}
        pagination
      />
    </div>
  );
}

export { SettingsDemandReportUsers };
export default SettingsDemandReportUsers;
